import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'

interface Variables {
  scheduleId: number
}

export const prepareTopics = async ({ scheduleId }: Variables) => {
  const res = await sendToApi<void>(`/schedules/${scheduleId}/prepare_topics`, {
    method: 'POST',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(buildErrorMessage(res.data?.errors) || 'An error occurred preparing topics.')
  }

  return res.data
}

export interface Options extends Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'> {}

export const usePrepareTopics = (options?: Options) => {
  return useMutation<void, Error, Variables>(prepareTopics, options)
}
